import Swiper, {Navigation, EffectCoverflow} from "../../assets/.npm/node_modules/swiper";

export default () => {
    let swiperDoc = new Swiper(".slider-document", {
        modules: [Navigation, EffectCoverflow],
        loop: true,
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 0,
            modifier: 1,
            slideShadows: false,
        },
        navigation: {
            nextEl: ".document-next",
            prevEl: ".document-prev",
        },
        breakpoints: {
            992: {
              slidesPerView: 3, 
              coverflowEffect: {
                rotate: 0,
                stretch: -20,
                depth: 150,
                modifier: 1,
                slideShadows: false,
                },
            },
        },
    });
}
  
